import * as React from "react";
import type { SVGProps } from "react";
const SvgIconPlay = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.66 1.06q-.49.02-.93.32c-.4.26-.68.7-.74 1.17-.03.2-.03 10.7 0 10.9.06.47.33.9.73 1.16q.34.23.69.3c.18.03.53.03.7 0 .15-.04.39-.12.5-.18l4.29-2.66 4.33-2.67c.35-.2.64-.6.75-1 .05-.21.06-.53.02-.74-.1-.44-.36-.84-.7-1.05-.3-.2-8.68-5.33-8.74-5.36-.24-.13-.61-.2-.9-.19M3.6 2.22l-.15.07q-.3.14-.33.43c-.02.14-.02 10.42 0 10.56q.05.3.35.45.24.1.47.03c.1-.03 1.85-1.1 8.66-5.32q.29-.17.28-.47t-.27-.44L8.28 4.87C5.3 3.05 4.02 2.27 3.94 2.24q-.16-.06-.34-.02"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconPlay;
